import * as React from 'react'
import { TableSeekerContextProvider } from 'ui-seeker/core'
import {useAppContextState} from "../../../../../../@hooks";
import {createContext} from "use-context-selector";

const Context = createContext({})

const initialState = {
	tableData: [], isLoading: false, dates: [], priceByNight: null,
	priceDetails: {}, priceRawDetails: {}, tableType: 'priceRanking', avgDates: []
}

export function CompetitionAnalyzerRankingTableProvider({children}) {
	const { state, updateState } = useAppContextState(initialState)

	return <Context.Provider value={{state, updateState}}>
		<TableSeekerContextProvider>
			{children}
		</TableSeekerContextProvider>
	</Context.Provider>
}

export default Context